import { colorAccentExtraDark, colorAccentExtraLight } from '@styles-lib/colors'
import Chart from 'chart.js/auto'

export const chartJSDefaultsFactory = () => () => {
    Chart.defaults.color = colorAccentExtraDark
    Chart.defaults.backgroundColor = colorAccentExtraLight
    Chart.defaults.font.family = 'DaxPro'
    Chart.defaults.font.size = 14
}
